import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, Select, Checkbox, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { useSaleRoDetailModel, IMaterialDetailModel } from "./saleRoDetailModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IStockStatisticDetail } from "../../../../../stock/statistic/stockStatisticService"
import { YhBut } from "@/components/YhButton";
import { formatNum, formatInt, formatDiscount, formatIntPoint } from "@/utils/utils";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { useDictModel } from "../../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addModalVisible: visible, detailAddForm, initPgCfg,detailEditForm, workDataSource, workPgCfg, addDataSource, searchWorkData, setWorkDataSource, resetWorkloadData, setSearchWorkData, setAddDataSource, workloadData, setAddModalVisible, transformsToDetailList } = useSaleRoDetailModel();
    const { getSelectedDictOne } = useDictModel();
    useEffect(() => {
        if (visible && mode == "add") {
            workloadData(workPgCfg, { customerCode: detailAddForm.customerCode })
            setSearchWorkData({ customerCode: detailAddForm.customerCode })
        } else if (visible && mode == "edit") {
            workloadData(workPgCfg, { customerCode: detailEditForm.customerCode })
            setSearchWorkData({ customerCode: detailEditForm.customerCode })
        }
    }, [detailAddForm.customerCode, detailEditForm.customerCode, visible])
    const column = (optype: number) => [
        {
            // title: '序号',
            title: Locale['SN'],
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编号',
            title: Locale['Material Code'],
            width: 100,
            dataIndex: 'materialCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 100,
            dataIndex: 'materialNameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,               
        }, {
            // title: '商品名称',
            title: Locale['Material Name'],
            width: 100,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '退货数量',
            title: Locale['Return Qty'],
            width: 120,
            dataIndex: 'backNum',
            editable: true,
        }, {
            // title: '退货单价',
            title: Locale['Return unit price'],
            width: 120,
            dataIndex: 'backPrice',
            editable: true,
        }, {
            // title: '退货金额',
            title: Locale['Return Amount'],
            width: 120,
            dataIndex: 'backAmount',
        }, {
            // title: '销售单号',
            title: Locale['Sales Doc No.'],
            width: 120,
            dataIndex: 'saleCode',
        }, {
            // title: '销售数量',
            title: Locale['Sales Qty'],
            width: 120,
            dataIndex: 'num',
        }, {
            // title: '销售折扣',
            title: Locale['Sales discount'],
            width: 120,
            dataIndex: 'discountRate',
            render: (t: string) => t + "%"

        }, {
            // title: '销售单价',
            title: Locale['Sales unit price'],
            width: 120,
            dataIndex: 'price',
        }, {
            // title: '已退数量',
            title: Locale['Returned quantity'],
            width: 120,
            dataIndex: 'sreturnNum',
        }, {
            // title: '仓库',
            title: Locale['Warehouse'],
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale['Shelf'],
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 120,
            fixed: "right",
            render: (text: any, record: IMaterialDetailModel) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={!!addDataSource.find(item => item.id === record.id)}
                />
            ) : (
                    <YhBut
                        type="delete"
                        // txt="删除"
                        txt={Locale['Delete']}
                        click={() => remove(record)}
                    />
                )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { backNum, backPrice, sreturnNum, num } = row
        backNum = +formatIntPoint(backNum);
        backPrice = +formatIntPoint(backPrice);
        sreturnNum = +formatIntPoint(sreturnNum);
        num = +formatIntPoint(num);
        let differNum = num - sreturnNum
        let newRow = {
            ...row,
            // backNum: +formatIntPoint(backNum, differNum, "销售退货数量≥销售数量-已退数量"),
            backNum: +formatIntPoint(backNum, differNum, Locale["Sales Return Qty ≥ Sales Qty - Returned Qty"]),
            backAmount: +(backNum > differNum ? 0 : backNum * backPrice).toFixed(2)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { backNum, backPrice, sreturnNum, num } = row
        backNum = +formatIntPoint(backNum);
        backPrice = +formatIntPoint(backPrice);
        sreturnNum = +formatIntPoint(sreturnNum);
        num = +formatIntPoint(num);
        let differNum = num - sreturnNum
        let newRow = {
            ...row,
            // backNum: +formatIntPoint(backNum, differNum, "销售退货数量≥销售数量-已退数量"),
            backNum: +formatIntPoint(backNum, differNum, Locale["Sales Return Qty ≥ Sales Qty - Returned Qty"]),
            backAmount: +(backNum > differNum ? 0 : backNum * backPrice).toFixed(2)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            // placeholder="商品编码"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Code']}
        />
        {language == "zh-CN" && <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value }) }}
            // placeholder="商品名称"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Name']}
        />}
        {language != "zh-CN" &&<Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, nameEn: e.target.value }) }}
            // placeholder="商品名称"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Name En']}
        />}
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">{Locale["Search"]}</Button>
        <Button onClick={() => mode == "add" ? resetWorkloadData({ customerCode: detailAddForm.customerCode }) : resetWorkloadData({ customerCode: detailEditForm.customerCode })} shape="round">{Locale["Reset"]}</Button>
    </div>
    const onOK = async () => {
        transformsToDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([])
        setSearchWorkData({})
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="销售退货单-选择配件"
        title={Locale["Sales Return Doc -Select Materials"]}
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title={Locale["List of materials to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workDataSource}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title={Locale["List of selected materials"]}>
            <Table
                rowKey={record => record.id as string}
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={addDataSource}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}